module.exports = __webpack_public_path__ + "static/media/foodtransport5.39b95eb8.jpg";